import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {WorkspacePremium, CheckBox, ReceiptLong} from 'views/icons';
import {Translate, translate} from 'views/module';

import moment from 'moment';

const CredentialsSection = (props) => {
  const {questions} = props;
  const {
    certificates = [],
  } = questions;

  return (
    <Stack alignItems="flex-start" width="100%" spacing={2} sx={{}}>
      {/* Pre-Vetted Banner */}
      <Stack
        direction="row" alignItems="center" spacing={1.5} width="100%"
        sx={{
          p: 1.5,
          borderRadius: 2,
          bgcolor: '#EBF6ED',
          boxSizing: 'border-box',
          border: '1px solid',
          borderColor: 'color.divider',
          m: 0,
        }}
      >
        <Box
          sx={{
            bgcolor: '#E6FAF0',
            borderRadius: '8px',
            p: 0.75,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckBox sx={{color: '#68A873', fontSize: 18}} />
        </Box>
        <Typography variant="body2" color="text.primary">
          <Translate expression='caregiverDetail.Credentials.ScreenedBanner' />
        </Typography>
      </Stack>
      {/* Qualifications Cards */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {xs: '1fr', sm: '1fr 1fr'},
          gap: 2,
          width: '100%',
        }}
      >
        {/* Caregiver Qualifications Card */}
        {
          certificates.map((c) => (
            <Stack
              key={c.type} direction="row" alignItems="flex-start" spacing={2}
              sx={{
                'p': 2,
                'borderRadius': 2,
                'bgcolor': 'color.white',
                'width': '100%',
                'boxSizing': 'border-box',
                'border': '1px solid',
                'borderColor': 'color.divider',
                'm': 0,
              }}
            >
              {/* Icon */}
              <Box sx={{borderRadius: 2, p: 1, display: 'flex', alignItems: 'center'}}>
                <WorkspacePremium sx={{color: '#6967F6', fontSize: 20}} />
              </Box>
              {/* Title, Description & Label */}
              <Stack spacing={1} alignContent="flex-start">
                <Typography variant="subtitle2" fontWeight="bold">
                  <Translate expression={`caregiverDetail.Credentials.CaregiverInfo.${c.type}.Type`} />
                </Typography>
                <Typography variant="body2" color="#686868">
                  {
                    translate(`caregiverDetail.Credentials.CaregiverInfo.${c.type}.Place`,
                        {orgName: c.issuingOrganization.trim() || translate('caregiverDetail.Credentials.OrgNameDefault')}) +
              (c.city.trim() ? `— ${c.city.trim()}` : '') +
              (c.dateObtained.trim() ? ` (${moment(c.dateObtained).format('YYYY')})` : '')
                  }
                </Typography>
              </Stack>
            </Stack>
          ))
        }
        {/* Background Check Card */}
        <Stack
          direction="row" alignItems="flex-start" spacing={2}
          sx={{
            'p': 2,
            'borderRadius': 2,
            'bgcolor': 'color.white',
            'width': '100%',
            'boxSizing': 'border-box',
            'border': '1px solid',
            'borderColor': 'color.divider',
            'm': 0,

          }}
        >
          {/* Icon */}
          <Box sx={{borderRadius: 2, p: 1, display: 'flex', alignItems: 'center'}}>
            <CheckBox sx={{color: '#6967F6', fontSize: 20}} />
          </Box>
          {/* Title, Description & Label */}
          <Stack spacing={1}>
            <Typography variant="subtitle2" fontWeight="bold">
              <Translate expression={`caregiverDetail.Credentials.BgCheckTitle`} />
            </Typography>
            <Typography variant="body2" color="#686868">
              <Translate
                expression={`caregiverDetail.Credentials.BgCheckSubtitle`}
                substitute={{orgNameDefault: translate('caregiverDetail.Credentials.OrgNameDefault')}}
              />
            </Typography>
          </Stack>
        </Stack>
        {/* Liability Insurance Card */}
        <Stack
          direction="row" alignItems="flex-start" spacing={2}
          sx={{
            'p': 2,
            'borderRadius': 2,
            'bgcolor': 'color.white',
            'width': '100%',
            'boxSizing': 'border-box',
            'border': '1px solid',
            'borderColor': 'color.divider',
            'm': 0,
          }}
        >
          {/* Icon */}
          <Box sx={{borderRadius: 2, p: 1, display: 'flex', alignItems: 'center'}}>
            <ReceiptLong sx={{color: '#6967F6', fontSize: 20}} />
          </Box>
          {/* Title, Description & Label */}
          <Stack spacing={1}>
            <Typography variant="subtitle2" fontWeight="bold">
              <Translate expression={`caregiverDetail.Credentials.LiabilityInsuranceTitle`} />
            </Typography>
            <Typography variant="body2" color="#686868">
              <Translate
                expression={`caregiverDetail.Credentials.LiabilityInsuranceSubtitle`}
                substitute={{orgNameDefault: translate('caregiverDetail.Credentials.OrgNameDefault')}}
              />
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

CredentialsSection.propTypes = {
  questions: PropTypes.object.isRequired,
};

export default CredentialsSection;
